export const getCartCalculatedValues = cart => {
    const { allDiscounts, uniqueDiscounts } = getDiscounts(cart);

    return {
        appliedEventCredit: calculateAppliedEventCredit(cart.items),
        appliedStoreCredit: calculateAppliedStoreCredit(cart.company_credit, cart.member_credit),
        discounts: allDiscounts,
        uniqueDiscounts,
        itemCount: cart.items.length,
        subtotal: cart.items.reduce((tally, item) => tally + item.subtotal, 0),
        subtotalWithoutDiscounts: cart.items.reduce((tally, item) => tally + item.price, 0),
        tax: cart.items.reduce((tally, item) => tally + item.tax, 0),
    };
};

export const mapApiCartToProps = cart => {
    return {
        ...cart,
        _calculated: getCartCalculatedValues(cart),
    };
};

export const calculateAppliedStoreCredit = (companyCredit, memberCredit) => {
    return companyCredit + memberCredit;
};

export const calculateAppliedEventCredit = cartItems => {
    const appliedEventCredit = cartItems.reduce((total, item) => {
        const eventCreditDiscounts = item.discounts.filter(discount => discount.type === 'event_credit');
        const eventCreditDiscountAmount = eventCreditDiscounts.reduce(
            (sum, discount) => sum + discount.promotional_discount,
            0
        );
        return total + eventCreditDiscountAmount;
    }, 0);

    return appliedEventCredit;
};

const getDiscounts = cart => {
    const allDiscounts = cart.items.reduce((tally, item) => [...tally, ...item.discounts], []);
    const uniqueDiscounts = [];

    allDiscounts.forEach(discount => {
        if (!uniqueDiscounts.some(uniqueDiscount => uniqueDiscount.promotional_code === discount.promotional_code)) {
            uniqueDiscounts.push(discount);
        }
    });

    return { allDiscounts, uniqueDiscounts };
};
